export default __webpack_public_path__ + "static/media/SuperToDo4.0a0d3c28.jpg";